import React, { useState } from "react";
import styles from "./CreateFeeComponent.module.css";

import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import ToClose from "../../components/ToClose/ToClose";
import HeadingAndData from "../../components/HeadingAndData/HeadingAndData";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import RadioComponent from "../../components/RadioComponent/RadioComponent";

import { FaRegFileAlt } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

const CreateFeeComponent = () => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    leaveType: "",
    totalLeaves: "",
    defaultLeave: "",
    gender: "male",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleRadioChange = (e) => {
    setFormData((prev) => ({ ...prev, gender: e.target.value }));
  };

  const handleSave = () => {
    console.log("Form Data:", formData);
    // Save logic here
  };

  const handleCancel = () => {
    setFormData({
      leaveType: "",
      totalLeaves: "",
      defaultLeave: "",
      gender: "male",
    });
  
  };

  return (
   
      <div className={styles.section}>
        <div className={styles.header}>
          <HeadingAndIcon
            icon={<FaRegFileAlt />}
            heading="Create Fee Component"
          />
          <ToClose onClose={() => dispatch(closeModal())} />
        </div>
        <div className={styles.content}>
          <div className={styles.form}>
            <HeadingAndDropDown
              label="Leave type"
              name="leaveType"
              value={formData.leaveType}
              onChange={handleChange}
              options={[
                { label: "Sick Leave", value: "sick" },
                { label: "Casual Leave", value: "casual" },
              ]}
              required
              placeholder="choose leave type"
            />

            <HeadingAndData
              label="Total Leaves"
              name="totalLeaves"
              placeholder="Enter Value"
              value={formData.totalLeaves}
              onChange={handleChange}
              required
            />

            <HeadingAndData
              label="Default leave"
              name="defaultLeave"
              placeholder="Enter value"
              value={formData.defaultLeave}
              onChange={handleChange}
              required
            />

            <div className={styles.genderSection}>
              <label className={styles.genderLabel}>Gender</label>
              <div className={styles.radioGroup}>
                <RadioComponent
                  name="gender"
                  value="male"
                  label="Male"
                  checked={formData.gender === "male"}
                  onChange={handleRadioChange}
                />
                <RadioComponent
                  name="gender"
                  value="female"
                  label="Female"
                  checked={formData.gender === "female"}
                  onChange={handleRadioChange}
                />
              </div>
            </div>

            <div className={styles.actions}>
              <SaveAndCancel onCancel={handleCancel} onSave={handleSave} />
            </div>
          </div>
        </div>
      </div>
    
  );
};

export default CreateFeeComponent;
